/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { usageTelemetryAddUsageTelemetry } from '../fn/usage-telemetry/usage-telemetry-add-usage-telemetry';
import { UsageTelemetryAddUsageTelemetry$Params } from '../fn/usage-telemetry/usage-telemetry-add-usage-telemetry';

@Injectable({ providedIn: 'root' })
export class UsageTelemetryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usageTelemetryAddUsageTelemetry()` */
  static readonly UsageTelemetryAddUsageTelemetryPath = '/usage-telemetry';

  /**
   * Saves usage telemetry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usageTelemetryAddUsageTelemetry()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usageTelemetryAddUsageTelemetry$Response(params: UsageTelemetryAddUsageTelemetry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = usageTelemetryAddUsageTelemetry(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Saves usage telemetry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usageTelemetryAddUsageTelemetry$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  usageTelemetryAddUsageTelemetry(params: UsageTelemetryAddUsageTelemetry$Params, context?: HttpContext): Observable<void> {
    const resp = this.usageTelemetryAddUsageTelemetry$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
